module.exports = __webpack_public_path__ + "static/music-app-38ce6eaf5bd3f2404e0bf130e8a1b091.gif";